<app-header #header class="section" scrollHref="#intro-section"></app-header>
<app-intro-section id="intro-section" class="section"></app-intro-section>
<app-stats-section class="section"></app-stats-section>
<app-skills-section class="section"></app-skills-section>
<app-projects-section class="section"></app-projects-section>
